module.exports = __webpack_public_path__ + "img/proposedVideos.02951fd8.png";